import Typography from '~/shared/components/Typography';
import CloudFIllGrowthAction from '~/shared/assets/icons/cloudfill1.svg';
import CloudFIllShrinkAction from '~/shared/assets/icons/cloudfill2.svg';

export default function TypeCell({ type }: { type: string }) {
  const text = type === 'Growth' ? 'Growth' : 'Shrink';
  return (
    <div className="flex items-center gap-[6px]">
      {type === 'Growth' ? (
        <CloudFIllGrowthAction className="w-[20px]" />
      ) : (
        <CloudFIllShrinkAction className="w-[20px]" />
      )}
      <Typography variant="p3" color={type === 'growth' ? 'success' : 'error'}>
        {text}
      </Typography>
    </div>
  );
}
